import React from "react";

const Ending = () => {
  return (
    <div className="md:w-96 mt-32 w-80 bg-black h-auto mx-auto text-white py-12 px-6">
      <div className="text-red-400 text-lg text-center pb-3">
        error syncronising
      </div>
      <div className="text-center font-bold text-2xl">
        Having issues? Chat with support Click on the Chat-icon at the down page
      </div>
      <div className="text-center pt-8">
        <a
          href="/registry"
          className="bg-blue-800 px-4 py-2 text-2xl text-center rounded"
        >
          Back
        </a>
      </div>
    </div>
  );
};

export default Ending;
